module.exports = __webpack_public_path__ + "img/weather19.4100a73b.png";